import { create } from 'zustand';

/**
 * Holds last-loaded analysis per session so detail pages avoid duplicate fetches.
 */
export const useBeachvisionStore = create((set) => ({
  analysesBySessionId: {},
  setSessionAnalysis: (sessionId, analysis) =>
    set((s) => ({
      analysesBySessionId: {
        ...s.analysesBySessionId,
        [String(sessionId)]: analysis,
      },
    })),
  clearSessionAnalysis: (sessionId) =>
    set((s) => {
      const next = { ...s.analysesBySessionId };
      delete next[String(sessionId)];
      return { analysesBySessionId: next };
    }),
}));
